module.exports = __webpack_public_path__ + "ico_gpx_small.svg";